import { useNavigate } from '@tanstack/react-router';
import { Card, Typography, IconButton } from '@/primer/components';
import { useAuth, useUserAttributes } from '@/api';
import { PageLayout, PageLoadingState } from '@/components/layout';

/**
 * Settings — Email sub-screen.
 *
 * Shows the creator's current email address. Email is set once during
 * onboarding via the OTP flow and cannot be changed after Sign in.
 */
export function SettingsEmail() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const { isLoading: isLoadingUserAttributes } = useUserAttributes();

  if (isLoadingUserAttributes) {
    return <PageLoadingState size="large" />;
  }

  return (
    <PageLayout className="py-6">
      <div className="flex flex-col gap-6">
        {/* Back navigation */}
        <div className="md:hidden flex items-center gap-4">
          <IconButton
            icon="chevron-left"
            onClick={() => navigate({ to: '/settings' })}
            aria-label="Back to Settings"
          />
          <Typography variant="header" size="h3" as="h3">
            Settings
          </Typography>
        </div>

        <Typography variant="header" size="h1" as="h1">
          Email
        </Typography>

        {/* Current email card */}
        <Card>
          <div className="p-5 flex flex-col gap-4">
            <div className="flex flex-col gap-1 min-w-0">
              <Typography variant="body" size="medium" color="bodylighter">
                Current email
              </Typography>
              <Typography variant="body" size="medium" className="truncate">
                {user?.email}
              </Typography>
            </div>
          </div>
        </Card>
      </div>
    </PageLayout>
  );
}

export default SettingsEmail;
